import InputValidator from "./InputValidator";

export default class RangeValidator extends InputValidator {
    constructor(element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, message: string) {
        super(element, message);
    }

    public validate(): boolean {
        this.valid = !this.element.validity.rangeUnderflow || !this.element.validity.rangeOverflow;

        this.emit();

        return this.valid;
    }
}
